import React from 'react'
import { CreateSupportAnnounce9Container } from '../../containers/Officer/CreateSupportAnnounce9Container'
export const CreateSupportAnnounce9Page = () => {
    return (
        <CreateSupportAnnounce9Container />
    )
}
